import { createSlice } from '@reduxjs/toolkit'
import type { RootState } from '../store'

 // Define a type for the slice state
export interface IInventoryViewerModalState {
    isOpen: boolean
}

 // Define the initial state using that type
const initialState: IInventoryViewerModalState = {
    isOpen: false,
}

export const inventoryViewerModalSlice = createSlice({
    name: 'inventoryViewerModal',
     // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setInventoryViewerModalHidden: (state) => {
            state.isOpen = false
        },
        setInventoryViewerModalOpen: (state) => {
            state.isOpen = true
        },
    },
})

export const { setInventoryViewerModalHidden, setInventoryViewerModalOpen } = inventoryViewerModalSlice.actions

export default inventoryViewerModalSlice.reducer
